/* eslint-disable no-debugger */
import React, { useState, useEffect } from "react";
import {
  message,
  Input,
  Button,
  Form,
  Space,
  Tooltip,
  Drawer,
  Card,
  Modal,
  Col,
  Row,
  DatePicker,
  TreeSelect,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import moment from "moment";
import { Trans, useTranslation } from "react-i18next";
import {
  deleteGroup,
  getPagingGroups,
  insertGroup,
  updateGroup,
  deleteManyGroup,
  getManagementGroupPage,
  getManagementApplication,
} from "../../helpers/helper";
import DataTable from "../../Components/Common/DataTable";
import { extractManyId } from "../../common/function";
import { useUserDetails } from "../../context/UserDetailContext";

const { confirm } = Modal;
const { TreeNode } = TreeSelect;

const GroupsManagement = () => {
  const { t } = useTranslation();
  document.title = t("managerGroup");

  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [listGroup, setListGroup] = useState([]);
  const [visibleForm, setVisibleForm] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [treeDataDepartment, setTreeDataDepartment] = useState([]);

  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [indexPage, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingDeleteRows, setLoadingDeleteRows] = useState(false);
  const { userDetails } = useUserDetails();

  const getAllData = async (_prams, indexPage) => {
    try {
      const params = _prams
        ? _prams
        : {
            pageIndex: indexPage,
            pageSize: pageSize,
            search: "",
          };
      const dataRes = await getPagingGroups(params);
      setTotalPage(dataRes?.totalPages);
      if (!dataRes) {
        message.error(t("requiredPermission"));
        return false;
      }
      const data = convertDataTable(dataRes?.data);
      return dataRes?.data ? data : false;
    } catch (error) {
      message.error(t("requiredPermission"));
      setTotalPage(0);
      return [];
    }
  };

  const convertDataTable = (dataArray) => {
    const data =
      dataArray.length > 0 &&
      dataArray.map((item) => {
        return {
          key: item._id,
          groupName: item.groupName,
          department: item.department ? item.department?.departmentName : "",
          departmentId: item.department ? item.department._id : "",
          companyId: item.company ? item.company._id : "",
          companyName: item.company ? item.company.companyName : "",
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
    return dataArray ? data : [];
  };

  const convertCompany = (dataArray) => {
    try {
      const data =
        dataArray.length > 0 &&
        dataArray.map((company) => {
          return {
            title: company?.companyName,
            value: `company_${company._id}`,
            key: `company_${company._id}`,
            children: company?.departments?.map((department) => {
              return {
                title: department?.departmentName,
                value: `department_${department._id}_company_${company._id}`,
                key: `department_${department._id}_company_${company._id}`,
                children: department?.groups?.map((group) => {
                  return {
                    title: group?.groupName,
                    value: `group_${group._id}_department_${department._id}_company_${company._id}`,
                    key: `group_${group._id}_department_${department._id}_company_${company._id}`,
                  };
                }),
              };
            }),
          };
        });
      return dataArray ? data : [];
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      try {
        const dataReq = await getManagementGroupPage();
        let data = await getManagementApplication();

        setTotalPage(dataReq.dataPage?.totalPages);
        const dataShowTable = convertDataTable(
          dataReq.dataPage?.data,
          dataReq.allCompanies
        );

        const company =
          userDetails?.role?.roleName === "SuperAdmin"
            ? data.allCompanies
            : data.allCompanies.filter(
                (item) => item._id === userDetails?.company?._id
              );

        const dataResDepartment = convertCompany(company || []);
        setTreeDataDepartment(dataResDepartment);
        setListGroup(dataShowTable);
        setLoading(false);
      } catch (error) {
        message.error(t("requiredPermission"));
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const onFinish = async (data) => {
    try {
      if (data.department) {
        const ids = extractManyId(data.department);
        data.department = ids.department;
        data.company = ids.company;
      }

      const dataReq = {
        groupName: data.groupName.trim().replace(/\s-\s/g, "-"),
        department: data.department,
        company: data.company,
      };

      if (!data.id) {
        const dataRes = await insertGroup(dataReq);
        dataRes.status === 1
          ? message.success(t("saveSuccess"))
          : message.error(t("saveFail"));
        formSearch.resetFields();
        handleRefresh();
      } else {
        const group = listGroup.find((group) => group.key === data.id);
        if (
          data.groupName === group.groupName &&
          data.department === group.department &&
          data.company === group.company
        ) {
          message.success(t("dataNotChange"));
          handleCloseDrawer();
        } else {
          const dataRes = await updateGroup(data.id, dataReq);
          dataRes.status === 1
            ? message.success(t("updateSuccess"))
            : message.error(`${dataRes.message}`);
          handleRefreshData();
        }
      }
      form.resetFields();
      handleCloseDrawer();
    } catch (error) {
      if (!data.id) message.error(t("permisstionDeniedAction"));
      else message.error(t("permisstionDeniedAction"));

      form.resetFields();
      handleCloseDrawer();
      formSearch.resetFields();
    }
  };

  const handleResetForm = () => {
    form.resetFields();
  };

  const handleRefresh = async () => {
    const _params = {
      pageIndex: 1,
      pageSize: 10,
      search: "",
    };
    const dataRes = await getAllData(_params, indexPage);
    setPageIndex(1);
    setListGroup(dataRes.length > 0 ? dataRes : listGroup);
    formSearch.resetFields();
  };

  const handleSearch = async () => {
    const dataForm = formSearch.getFieldsValue();
    if (!Object.values(dataForm).some((item) => !!item)) {
      return;
    }
    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, 1);
    setListGroup(dataRes.length > 0 ? dataRes : false);
    setPageIndex(1);
  };

  const onPageChange = (page, page_size) => {
    setPageIndex(page);
    setPageSize(page_size);
    onPageChangeAtSearch(page, page_size);
  };

  const onPageChangeAtSearch = async (indexPage, page_size) => {
    setLoading(true);
    const params = {
      pageIndex: indexPage,
      pageSize: page_size,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, indexPage);
    setListGroup(dataRes.length > 0 ? dataRes : false);
    setLoading(false);
  };

  const onEdit = (key) => {
    const dataEdit = listGroup.filter((item) => item.key === key);
    const extractId = (departmentId, companyId) => {
      let id = `department_${departmentId}_company_${companyId}`;

      return id;
    };

    form.setFieldsValue({
      groupName: dataEdit[0].groupName,
      id: dataEdit[0].key,
      department: extractId(dataEdit[0].departmentId, dataEdit[0].companyId),
    });
    setDrawerTitle(t("editGroup"));
    showDrawer();
  };
  const getFormSearch = () => {
    const dataForm = formSearch.getFieldsValue();
    return {
      groupName: dataForm.groupName || "",
      departmentName: dataForm.departmentName || "",
      companyName: dataForm.companyName || "",
      createdTime: dataForm.createdTime || "",
    };
  };
  const handleRefreshData = async (index_page) => {
    const _params = {
      pageIndex: index_page ? index_page : indexPage,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(_params);
    setListGroup(dataRes);
    setPageIndex(index_page ? index_page : indexPage);
  };
  const handleRefreshDataDelete = async (countRemove) => {
    const indexPageNew =
      listGroup.length == countRemove
        ? indexPage === 1
          ? 1
          : indexPage - 1
        : indexPage;
    handleRefreshData(indexPageNew);
  };
  const onDelete = async (key) => {
    try {
      const dataRes = await deleteGroup(key);
      if (dataRes.status === 1) {
        message.success(t("deleteSuccess"));
        handleRefreshDataDelete(1);
      } else {
        message.error(t("deleteFail"));
      }
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
    }
  };

  const showModalConfirmDelete = (record) => {
    confirm({
      title: t("confirmDeleteGroup"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDelete(record);
      },
      onCancel() {},
    });
  };

  const validateInput = (_, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject();
    }
    return Promise.resolve();
  };

  const validateSelect = (_, value) => {
    if (!value || value.length === 0) {
      return Promise.reject();
    }
    return Promise.resolve();
  };

  const columns = [
    {
      title: t("company"),
      dataIndex: "companyName",
    },
    {
      title: t("department"),
      dataIndex: "department",
    },
    {
      title: t("group"),
      dataIndex: "groupName",
    },
    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
    {
      title: t("action"),
      dataIndex: "",
      render: (_, record) => (
        <Space>
          <Tooltip title={t("edit")}>
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              size="small"
              onClick={() => onEdit(record.key)}
            />
          </Tooltip>
          <Tooltip title={t("delete")}>
            <Button
              type="danger"
              shape="circle"
              icon={<DeleteOutlined />}
              size="small"
              onClick={() => showModalConfirmDelete(record.key)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const onClose = () => {
    setVisibleForm(false);
  };

  const showDrawer = () => {
    setVisibleForm(true);
  };

  const handleNewGroup = () => {
    setDrawerTitle(t("createGroup"));
    showDrawer();
    form.resetFields();
  };

  const handleCloseDrawer = () => {
    setDrawerTitle("");
    setVisibleForm(false);
    form.resetFields();
  };

  const handleDeleteSelectRows = async () => {
    confirm({
      title: (
        <Trans
          i18nKey="deleteConfirmationGroup"
          values={{ count: selectedRowKeys.length }}
        />
      ),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        OnDeleteSelectRows();
      },
      onCancel() {},
    });
  };

  const OnDeleteSelectRows = async () => {
    try {
      setLoadingDeleteRows(true);

      const dataRes = await deleteManyGroup({ data: { ids: selectedRowKeys } });

      if (dataRes.status === 1) {
        message.success(
          <Trans
            i18nKey="deleteManyGroupSuccess"
            values={{ count: dataRes.data.deletedCount }}
          />
        );
        handleRefreshDataDelete(dataRes.data.deletedCount);
      } else {
        message.error(t("deleteFail"));
      }
      setSelectedRowKeys([]);
      setLoadingDeleteRows(false);
    } catch (error) {
      setLoadingDeleteRows(false);
      message.error(t("deleteFail"));
    }
  };

  return (
    <>
      <div className="page-content">
        <Card bordered={false}>
          <Form
            form={formSearch}
            layout="vertical"
            onFinish={handleSearch}
            autoComplete="off"
          >
            <Row gutter={10}>
              <Col hidden={true}>
                <Form.Item name="id" label="Id">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="companyName" label={t("companyName") + ":"}>
                  <Input
                    placeholder={t("placeHolderCompanyName")}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="departmentName"
                  label={t("departmentName") + ":"}
                >
                  <Input
                    placeholder={t("placeHolderDepartmentName")}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="groupName" label={t("groupName") + ":"}>
                  <Input
                    placeholder={t("placeHolderGroupName")}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="createdTime" label={t("createdTime") + ":"}>
                  <DatePicker
                    placeholder={t("createdTime")}
                    format={"DD/MM/YYYY"}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item className="">
              <Space>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => handleSearch()}
                >
                  {t("search")}
                </Button>

                <Button type="primary" onClick={handleNewGroup}>
                  {t("createGroup")}
                </Button>

                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => handleRefresh()}
                >
                  {t("reload")}
                </Button>
                <Button
                  disabled={selectedRowKeys.length === 0}
                  loading={loadingDeleteRows}
                  type="danger"
                  htmlType="button"
                  onClick={() => handleDeleteSelectRows()}
                >
                  {t("delete")}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
        <div>
          <Drawer
            title={drawerTitle}
            placement={"right"}
            width={"30%"}
            onClose={onClose}
            open={visibleForm}
            bodyStyle={{
              paddingBottom: 80,
            }}
            style={{ marginTop: "70px" }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
            >
              <Row>
                <Col hidden={true}>
                  <Form.Item name="id" label="Id">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="groupName"
                    label={t("groupName")}
                    rules={[
                      {
                        required: true,
                        validator: validateInput,
                        message: t("validateGroupName"),
                      },
                      {
                        type: "string",
                        min: 1,
                      },
                    ]}
                    style={{ marginBottom: "22px" }}
                  >
                    <Input
                      placeholder={t("placeHolderGroupName")}
                      allowClear={true}
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name="department"
                    label="Bộ phận"
                    style={{ marginBottom: "22px" }}
                    rules={[
                      {
                        required: true,
                        validator: validateSelect,
                        message: "Vui lòng nhập tên bộ phận!",
                      },
                    ]}
                  >
                    <TreeSelect
                      showSearch
                      treeNodeFilterProp="title"
                      style={{ width: "100%" }}
                      placeholder="Chọn công ty và bộ phận"
                      allowClear
                      treeDefaultExpandAll
                      value={treeDataDepartment}
                    >
                      {treeDataDepartment &&
                        treeDataDepartment?.map((data) => {
                          return (
                            <TreeNode
                              key={data.key}
                              value={data.value}
                              title={data.title}
                              disabled
                            >
                              {data.children.length > 0
                                ? data.children.map((child) => {
                                    return (
                                      <TreeNode
                                        key={child.key}
                                        value={child.value}
                                        title={child.title}
                                      ></TreeNode>
                                    );
                                  })
                                : null}
                            </TreeNode>
                          );
                        })}
                    </TreeSelect>
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item className="mt-3">
                <Space>
                  <Button type="primary" htmlType="submit">
                    {t("save")}
                  </Button>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => handleResetForm()}
                  >
                    {t("reload")}
                  </Button>
                  <Button type="danger" onClick={handleCloseDrawer}>
                    {t("close")}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Drawer>
        </div>
        <DataTable
          listData={listGroup}
          pageSize={pageSize}
          columns={columns}
          indexPage={indexPage}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </div>
    </>
  );
};
export default GroupsManagement;
